module.exports = __webpack_public_path__ + "img/thermometer.c84df577.svg";